import { DefaultTheme } from '../../components/theme';

export const CSS = {
	container: 'c-RadioInput',
	label: 'c-RadioInput__label',
	disabled: 'c-RadioInput__disabled',
};

export const Style = {
	[CSS.container]: {
		display: 'flex',
		'align-items': 'center',
	},
	[CSS.disabled]: {
		color: `${DefaultTheme.font.color.error} !important`,
		'pointer-events': 'none',
	},
};
